import React, { useEffect, useState } from 'react';
import { Link, Outlet, Route } from 'react-router-dom';
import ROUTES from '../../nav/Routes';

function Layout() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // you can use 'auto' for instant scroll
        });
    };

    useEffect(() => {
        const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');
        const navLinks = document.querySelectorAll('#navmenu ul li a');

        function mobileNavToggle() {
            document.body.classList.toggle('mobile-nav-active');
            mobileNavToggleBtn.classList.toggle('bi-list');
            mobileNavToggleBtn.classList.toggle('bi-x');
        }

        function closeMobileMenu() {
            if (document.body.classList.contains('mobile-nav-active')) {
                document.body.classList.remove('mobile-nav-active');
                mobileNavToggleBtn.classList.add('bi-list');
                mobileNavToggleBtn.classList.remove('bi-x');
            }
        }

        if (mobileNavToggleBtn) {
            mobileNavToggleBtn.addEventListener('click', mobileNavToggle);
        }

        navLinks.forEach(link => {
            link.addEventListener('click', closeMobileMenu);
        });

        // Cleanup events
        return () => {
            if (mobileNavToggleBtn) {
                mobileNavToggleBtn.removeEventListener('click', mobileNavToggle);
            }
            navLinks.forEach(link => {
                link.removeEventListener('click', closeMobileMenu);
            });
        };
    }, []);


    // useEffect(() => {
    //     const playAudio = () => {
    //         const audio = new Audio('assets/audio/manncar.mp3');
    //         audio.play().catch((e) => {
    //             console.warn('Audio play failed:', e);
    //         });

    //         // Remove all listeners after playing
    //         window.removeEventListener('click', playAudio);
    //         window.removeEventListener('touchstart', playAudio);
    //         window.removeEventListener('keydown', playAudio);
    //     };

    //     // Attach listeners to detect a real user gesture
    //     window.addEventListener('click', playAudio);
    //     window.addEventListener('touchstart', playAudio);
    //     window.addEventListener('keydown', playAudio);

    //     return () => {
    //         window.removeEventListener('click', playAudio);
    //         window.removeEventListener('touchstart', playAudio);
    //         window.removeEventListener('keydown', playAudio);
    //     };
    // }, []);


    return (
        <div>
            { }
            <div class="index-page">
                <header id="header" class="header d-flex align-items-center fixed-top">
                    <div class="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

                        <Link to={ROUTES.index.name} onClick={scrollToTop} class="logo d-flex align-items-center me-auto me-lg-0">

                            <img src="assets/img/logo.png" />

                            {/* <h1 class="sitename">MANN Carrier</h1>
                            <span>.</span> */}
                        </Link>

                        <nav id="navmenu" class="navmenu">
                            <ul>
                                <li><Link to={ROUTES.index.name} onClick={scrollToTop}>Home</Link></li>
                                <li><Link to={ROUTES.about.name} onClick={scrollToTop}>About</Link></li>
                                <li><Link to={ROUTES.gallery.name} onClick={scrollToTop}>Gallery</Link></li>
                                <li><Link to={ROUTES.services.name} onClick={scrollToTop}>Services</Link></li>
                                <li><Link to={ROUTES.career.name} onClick={scrollToTop}>Career</Link></li>
                                {/* <li><a href="#team">Team</a></li> */}
                                {/* <li class="dropdown"><a href="#"><span>Dropdown</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                                    <ul>
                                        <li><a href="#">Dropdown 1</a></li>
                                        <li class="dropdown"><a href="#"><span>Deep Dropdown</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                                            <ul>
                                                <li><a href="#">Deep Dropdown 1</a></li>
                                                <li><a href="#">Deep Dropdown 2</a></li>
                                                <li><a href="#">Deep Dropdown 3</a></li>
                                                <li><a href="#">Deep Dropdown 4</a></li>
                                                <li><a href="#">Deep Dropdown 5</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="#">Dropdown 2</a></li>
                                        <li><a href="#">Dropdown 3</a></li>
                                        <li><a href="#">Dropdown 4</a></li>
                                    </ul>
                                </li> */}
                                <li><Link to={ROUTES.contact.name} onClick={scrollToTop}>Contact</Link></li>

                            </ul>
                            <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
                        </nav>

                        <Link class="btn-getstarted" to={ROUTES.planttree.name} onClick={scrollToTop}> Plant a Tree</Link>

                    </div>
                </header>



                <Outlet />




                <footer id="footer" class="footer dark-background py-5">

                    <div class="footer-top my-5">
                        <div class="container mb-5">
                            <div class="row gy-4">
                                <div class="col-lg-4 col-md-6 footer-about">
                                    <a href="index.html" class="logo d-flex align-items-center">
                                        <span class="sitename">Mann Carriers LLC</span>
                                    </a>
                                    <div class="footer-contact pt-3">
                                        <p class="mt-3"><strong>Phone:</strong> <span>+1 5164562280</span></p>
                                        <p><strong>Email:</strong> <span>info@manncarriers.com</span></p>
                                    </div>
                                    <div class="social-links d-flex mt-4">
                                        <a href=""><i class="bi bi-twitter-x"></i></a>
                                        <a href=""><i class="bi bi-facebook"></i></a>
                                        <a href=""><i class="bi bi-instagram"></i></a>
                                        <a href=""><i class="bi bi-linkedin"></i></a>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-3 footer-links">
                                    <h4>Useful Links</h4>
                                    <ul>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.index.name} onClick={scrollToTop}>Home</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.about.name} onClick={scrollToTop}>About us</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.services.name} onClick={scrollToTop}>Services</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.contact.name} onClick={scrollToTop}>Contact</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.planttree.name} onClick={scrollToTop}>Plant a Tree</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.career.name} onClick={scrollToTop}>Career</Link></li>
                                        {/* <li><i class="bi bi-chevron-right"></i> <a href="#"> Terms of service</a></li> */}
                                        {/* <li><i class="bi bi-chevron-right"></i> <a href="#"> Privacy policy</a></li> */}
                                    </ul>
                                </div>

                                <div class="col-lg-2 col-md-3 footer-links">
                                    <h4>Our Services</h4>
                                    <ul>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.services.name} onClick={scrollToTop}>Services</Link></li>

                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.services.name} onClick={scrollToTop}>Freight Transportation</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.services.name} onClick={scrollToTop}>Parcel & Courier</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.services.name} onClick={scrollToTop}>GPS Vehicle Tracking</Link></li>
                                        <li><i class="bi bi-chevron-right"></i> <Link to={ROUTES.login.name} onClick={scrollToTop}>Login</Link></li>
                                    </ul>
                                </div>

                                <div class="col-lg-4 col-md-12 footer-newsletter">
                                    <h4>Our Newsletter</h4>
                                    <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
                                    <form class="php-email-form">
                                        <div class="newsletter-form">
                                            <input type="email" name="email" />
                                            <input type="submit" value="Subscribe" />
                                        </div>
                                        <div class="loading">Loading</div>
                                        <div class="error-message"></div>
                                        <div class="sent-message">Your subscription request has been sent. Thank you!</div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="copyright">
                        <div class="container text-center">
                            <p>© <span>Copyright</span> <strong class="px-1 sitename">Mann Carriers LLC.</strong> <span>All Rights Reserved</span></p>
                            <div class="credits">
                                Designed by <a href="https://whizinfo.com/">Whizinfo Technologies</a>
                            </div>
                        </div>
                    </div>

                </footer>
            </div>
        </div>
    )
}

export default Layout;